module.exports = __webpack_public_path__ + "static/media/ThumbUpGreen.dfa9455d.svg";